import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { MyAxios } from "../../data/api.axios";
import { apiURL } from "../../data/api.url";
import MainButton from "../../components/Button";
import { LogoIcon } from "../../assets/svgs";
import { useNavigate } from "react-router-dom";
import { getAppTheme } from "../../utils/theme";
import { appName } from "../../utils/constants";
import SpinnerIcon from "../../assets/svgs/spinner";

const schema = yup.object().shape({
  siteUrl: yup.string().required("Sorry, this URL is already taken."),
});

export const SiteRegisterPage = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const handleNavigation = () => {
    navigate("/signup");
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data: { siteUrl: string }) => {
    try {
      setIsLoader(true);
      console.log(data);

      const response = await MyAxios.post(apiURL.registerBusiness, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("Site egistered Successfully:", response.data);
      setIsLoader(false);
    } catch (error) {
      console.error("Error during login:", error);
      alert("Failed to login. Please check your credentials.");
      setIsLoader(false);
    }
  };

  const Message = () => {
    alert("Button clicked!");
  };

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  return (
    <div
      className=" bg-bg bg-center min-h-screen w-full py-4 flex items-center justify-center"
      style={{
        backgroundImage: `${
          getAppTheme() === "dark"
            ? "url('/assets/images/darkmode.png')"
            : "url('/assets/images/bgLight.png')"
        }`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {" "}
      <div className="bg-bgCard px-8 pt-4 pb-8 rounded-lg flex flex-col gap-y-5 shadow-md w-full max-w-md">
        <div className="flex justify-center">
          <LogoIcon />
        </div>
        <div>
          <p className=" font-semibold my-2 text-center text-3xl">
            Create Your Site
          </p>
          <p className="text-center mb-4 font-normal text-sm text-text">
            Set up your unique business URL quickly!
          </p>
        </div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-12">
            <div className="relative">
              <input
                type="text"
                {...register("siteUrl")}
                className={`w-full pl-3 pr-12 focus-visible:outline-none h-[50px] bg-bgCard border border-text rounded ${
                  errors.siteUrl ? "border-danger" : "border-text"
                }`}
                placeholder="Your Site"
              />
              <span className="absolute cursor-pointer top-3 right-2 flex justify-center items-center text-gray-500">
                {appName.toLocaleLowerCase()}.com
              </span>
              {errors.siteUrl && (
                <p className="text-danger text-sm mt-1">
                  {errors.siteUrl.message}
                </p>
              )}
            </div>

            <div className="">
              <div className=" text-center mt-2">
                <span className=" text-xs font-normal font-[Poppins] leading-tight">
                  By creating your site, you agree to our platform's guidelines
                  for acceptable content
                </span>
              </div>

              <MainButton
                type="submit"
                label={isLoader ? <SpinnerIcon /> : "Continue"}
                onClick={Message}
                className=" mt-5 bg-gradient-to-br from-gradientOne to-gradientTwo h-[55px] focus:outline-none focus:ring-0 rounded-lg justify-center items-center gap-2.5 inline-flex w-full text-base font-medium "
              ></MainButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
